import React from 'react'
import Section from '@components/layout/Section/Section'
import SectionHeading from '@components/layout/Section/SectionHeading/SectionHeading'
import { P } from '@components/typography'

const Disclaimer = () => (
  <Section>
    <SectionHeading heading="Earnings and Income Disclaimer" />
    <P>
      Entrepreneur Insight Limited (“Entrepreneur Seminar”) cannot and does not make any guarantees
      about your ability to get results or earn any money with our ideas, information, tools, or
      strategies. You should know that all products and services by our company are for educational
      and informational purposes only. Nothing on this page, any of our websites, or any of our
      content or curriculum is a promise or guarantee of results, investment or future earnings, and
      we do not offer any legal, medical, tax or other professional advice.
    </P>
    <P>
      Any financial numbers referenced here, or on any of our sites, are illustrative of concepts
      only and should not be considered average earnings, exact earnings, or promises for actual or
      future performance. Use caution and always consult your accountant, lawyer or professional
      advisor before acting on this or any information related to a lifestyle change or your
      business or finances. You alone are responsible and accountable for your decisions, actions
      and results in life, and by your registration here you agree not to attempt to hold us liable
      for your decisions, actions or results, at any time, under any circumstance.
    </P>
  </Section>
)

export default Disclaimer
